<template>
    <div class="page addGift">
        <form @submit.prevent="addGCard" class="container">
            <div class="formRow">
                <input type="text" placeholder="Card Number*" v-model="giftCardNumber" required>
            </div>
            <div class="formRow twin">
                <div>
                    <input type="text" placeholder="CVV*" v-model="cvv" required>
                </div>
                <div class="caption">
                    *Required fields
                </div>
            </div>
            <div class="botBtn">
                <div class="container">
                    <button class="btnlink zbg" v-if="user">
                        Save gift card
                    </button>
                    <button class="btnlink zbg" v-else>
                        Use gift card
                    </button>
                </div>
            </div>
        </form>
    </div>
</template>

<script>
    export default {
        name: "AddGift",
        data(){
            return{
                giftCardNumber: null,
                cvv: null,
                gift_cards_list: [],
            }
        },
        created() {
            this.$store.commit("shared/setTopBar", {title: "Manage Cards", showBackButton: true, showBag: false}, {root: true});
            if(!this.user){
                if(this.$store.state.cart.cart.guestGiftCardList){
                    this.gift_cards_list = this.$store.state.cart.cart.guestGiftCardList;
                }
            }
        },
        methods:{
            addGCard(){
                if(!this.giftCardNumber.length){
                    this.$store.commit("shared/setAlert", `Missing required  parameter: Card Number`)
                    return false;
                }
                if(!this.cvv.length){
                    this.$store.commit("shared/setAlert", `Missing required  parameter: CVV`)
                    return false;
                }
                if(this.user){
                    this.$store.dispatch("giftcard/linkGiftToUser",{
                        data: {gift_card_number: this.giftCardNumber, cvv: this.cvv},
                        callback: (res) => {
                            this.$router.go(-1);
                        }
                    });
                }
                else{
                    this.$store.dispatch("giftcard/linkGiftToGuestUser",{
                        data: {giftCardNumber: this.giftCardNumber, cvv: this.cvv},
                        callback: (res) => {
                            if(this.gift_cards_list.some(el => el.card_id === res.data.card_number)){
                                this.$store.commit("shared/setAlert", "This gift card alrady added");
                            }else{
                                if(res.data.balance > 0 && res.data.balance != undefined){
                                    this.gift_cards_list.push({'balance': res.data.balance, 'card_id': res.data.card_number, 'title': 'Gift Card', 'cvv': this.cvv});
                                    this.$store.commit("cart/setGiftCardsList", this.gift_cards_list);
                                    this.$router.go(-1);
                                }else if(res.data.balance == 0){
                                    this.$store.commit("shared/setAlert", "This gift card is empty");
                                }else{
                                    this.$store.commit("shared/setAlert", "This gift card does not exist");
                                }
                            }
                        }
                    });
                }
            }
        }
    }
</script>

<style scoped>

</style>
